module.exports = __webpack_public_path__ + "static/media/explore-image-3.9e149ac6.jpg";